import useGetAlertData from '../../hooks/useGetAlertData';
import TrackedLink from '../TrackedLink';
import AbstractBanner from './AbstractBanner/AbstractBanner';
import { memo } from 'react';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AlertBannerContainer = () => {
  const alerts = useGetAlertData();
  if (alerts.length <= 0) {
    return null;
  }
  const alertBanners = alerts.map((alert, index) => {
    const {
      alertType,
      level,
      link
    } = alert;
    const alertTitleTranslationKey = `alerts.${alertType}.title`;
    const alertDescriptionTranslationKey = `alerts.${alertType}.description`;
    const alertCtaTranslationKey = `alerts.${alertType}.linkText`;
    if (!isValidI18nKey(alertTitleTranslationKey) || !isValidI18nKey(alertDescriptionTranslationKey)) {
      return null;
    }
    const callToActionLink = isValidI18nKey(alertCtaTranslationKey) && link ? /*#__PURE__*/_jsx(TrackedLink, {
      marginInlineStart: "250",
      "data-test-id": `alarm-banner-link`,
      href: link,
      underline: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: alertCtaTranslationKey
      })
    }) : null;
    const testId = `${alertType}-banner-${index}`;
    return /*#__PURE__*/_jsxs(AbstractBanner, {
      isCloseable: false,
      type: level,
      "data-test-id": testId,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: alertTitleTranslationKey
      }),
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: alertDescriptionTranslationKey
      }), callToActionLink]
    }, testId);
  });
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "alertBannerContainer",
    children: alertBanners
  });
};
export default /*#__PURE__*/memo(AlertBannerContainer);